export default {
  'environments.title': 'Gestionar Entornos',
  'environments.type.development': 'Desarrollo',
  'environments.type.testing': 'Pruebas',
  'environments.type.production': 'Producción',
  'environments.permissions.description': 'Agregue o retire quién puede acceder al entorno {name}.',
};
